import { useState } from "react"

export const VariableScriptsArchive = () => {
    const [state, setState] = useState({
        name: "",
        script_Type: "",
        episodes_count: "",
        film_duration: '',
        duration_minutes: "",
        author_name: "",
        thumbnail: '',
        creative_work_type_id: "",
        creative_work_type_name: "",
        description: "",
        startDate: "",
        endDate: "",
        status: null,
        open: false,
        openEdit: false,
        arr1: [],
        Load: false
    })
    const setStateCustom = (variableName, value) => {
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const setOpen = (value) => {
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };
    const setopenEdit = (value) => {
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };
    const handleEdit = (event, arr) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            arr1: arr,
            openEdit: true
        }));
    }
    const handleChangeDate = (range) => {
        const [startDatee, endDatee] = range;
        setState((prevState) => ({
            ...prevState,
            startDate: startDatee,
            endDate: endDatee
        }));
    };
    return {
        ...state,
        state,
        setState,
        handleEdit,
        setOpen,
        setopenEdit,
        setStateCustom,
        setLoad, handleChangeDate
    }
}
